var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"icon is-large"},[_c('font-awesome-icon',{staticClass:"fa-2x",attrs:{"icon":"spinner","pulse":""}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }